if (!customElements.get('custom-tabs')) {
  class CustomTabs extends HTMLElement {
    constructor() {
      super();
      this.bars = this.querySelectorAll('.custom-tabs__bar');
      this.tabs = this.querySelectorAll('.custom-tabs__tab');
      this.bars.forEach((bar, index) => {
        bar.addEventListener('click', () => {
          this.setActive(index);
        });
      });
    }

    closeAll() {
      this.bars.forEach(b => b.removeAttribute('data-active'));
      this.tabs.forEach(t => t.removeAttribute('data-active'));
    }

    setActive(index) {
      if (this.bars[index].hasAttribute('data-active')) {
        this.bars[index].removeAttribute('data-active');
        this.tabs[index].removeAttribute('data-active');
      } else {
        this.closeAll();
        this.bars[index].setAttribute('data-active', '');
        this.tabs[index].setAttribute('data-active', '');

        // Custom smooth scroll to the top of the selected bar
        const barTop = this.bars[index].getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: barTop - 70,
          behavior: 'auto'
        });
      }
    }
  }
  customElements.define('custom-tabs', CustomTabs);
}
